"use strict";

// Class definition
var ChecklistCRM = function () {
	// Base elements
	var _checklistEl;


	// Private functions
	var checklistFunctions = function () {

	}


	return {
		// public functions
		init: function () {
			_checklistEl = KTUtil.getById('checklist_crm');

			checklistFunctions();
		}
	};
}();

jQuery(document).ready(function () {
	ChecklistCRM.init();
});
